import React, {
    useEffect,
    useState,
} from "react";

import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

import {
    Link,
} from "react-router-dom";

import Layout from "../components/layoutBlack";
import Breadcrumbs from "../components/breadcrumbs";
import EmailIcon from "../assets/images/icons/icon-email.png";

import { config } from "../utils/constants";

const REACT_APP_API_URL =
    config.url.REACT_APP_API_URL;


const RequestPasswordReset = () => {
    const [
        submitted,
        setSubmitted,
    ] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const formik = useFormik({
        initialValues: {
            email: "",
        },

        validationSchema: Yup.object({
            email: Yup.string()
                .trim()
                .email(
                    "Enter a valid email address"
                )
                .required(
                    "Email is required"
                ),
        }),

        onSubmit: async (
            values,
            {
                setSubmitting,
            }
        ) => {
            try {
                await axios.post(
                    `${REACT_APP_API_URL}/auth/password-reset/`,
                    {
                        email: values.email
                            .trim()
                            .toLowerCase(),
                    }
                );
            } catch (error) {
                /*
                 * The backend always responds with the same
                 * generic message regardless of outcome, so a
                 * network-level failure is the only thing worth
                 * distinguishing here -- and even then, we still
                 * show the same message to avoid revealing
                 * anything about the account.
                 */
                console.error(
                    "Password reset request failed:",
                    error
                );
            } finally {
                setSubmitted(true);
                setSubmitting(false);
            }
        },
    });

    return (
        <div>
            <Layout>
                <div className="container p-t-80 p-b-10">
                    <Breadcrumbs />
                </div>

                <section className="bg0 p-t-30 p-b-20">
                    <div className="container">
                        <div className="txt-center">
                            <h2 className="ltext-105 cl2">
                                Forgot Your Password?
                            </h2>

                            <p className="stext-115 cl6 p-t-15">
                                Enter the email address
                                associated with your Molu
                                Wellness wholesale account.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="full-page-section bg0 p-t-30 p-b-125">
                    <div className="container">
                        <div
                            className="m-lr-auto"
                            style={{
                                maxWidth: "560px",
                            }}
                        >
                            <div className="bor10 p-lr-70 p-t-55 p-b-70 p-lr-15-lg">
                                {submitted ? (
                                    <div
                                        className="txt-center"
                                        role="status"
                                        aria-live="polite"
                                    >
                                        <h4 className="mtext-105 cl2 p-b-15">
                                            Check Your Email
                                        </h4>

                                        <p className="stext-102 cl6 p-b-30">
                                            If an account
                                            eligible for login
                                            exists with that
                                            email address, we've
                                            sent password reset
                                            instructions.
                                        </p>

                                        <Link
                                            to="/login"
                                            className="stext-101 cl1 hov-cl1 trans-04"
                                        >
                                            Return to Sign In
                                        </Link>
                                    </div>
                                ) : (
                                    <form
                                        method="post"
                                        onSubmit={
                                            formik.handleSubmit
                                        }
                                        noValidate
                                    >
                                        <div className="m-b-20">
                                            <label
                                                htmlFor="email"
                                                className="stext-102 cl3 p-b-8"
                                                style={{
                                                    display:
                                                        "block",
                                                }}
                                            >
                                                Email Address
                                            </label>

                                            <div className="bor8 how-pos4-parent">
                                                <input
                                                    id="email"
                                                    className="stext-111 cl2 plh3 size-116 p-l-62 p-r-30"
                                                    type="email"
                                                    name="email"
                                                    placeholder="Email address"
                                                    autoComplete="email"
                                                    value={
                                                        formik
                                                            .values
                                                            .email
                                                    }
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    onBlur={
                                                        formik.handleBlur
                                                    }
                                                />

                                                <img
                                                    className="how-pos4 pointer-none"
                                                    src={
                                                        EmailIcon
                                                    }
                                                    alt=""
                                                />
                                            </div>

                                            {formik.touched
                                                .email &&
                                            formik.errors
                                                .email ? (
                                                <div className="text-danger mt-1 text-sm p-t-5">
                                                    {
                                                        formik
                                                            .errors
                                                            .email
                                                    }
                                                </div>
                                            ) : null}
                                        </div>

                                        <button
                                            className="flex-c-m stext-101 cl0 size-121 bg3 bor1 hov-btn3 p-lr-15 trans-04 pointer"
                                            type="submit"
                                            disabled={
                                                formik.isSubmitting
                                            }
                                        >
                                            {formik.isSubmitting
                                                ? "Sending..."
                                                : "Send Reset Link"}
                                        </button>

                                        <div className="txt-center p-t-30">
                                            <Link
                                                to="/login"
                                                className="stext-102 cl1 hov-cl1 trans-04"
                                            >
                                                Return to Sign In
                                            </Link>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    );
};


export default RequestPasswordReset;
